import { Injectable, signal } from '@angular/core';

/**
 * Shared chrome state. The header is hidden on the home page (which has its
 * own branding) and shows a per-page title image everywhere else.
 *
 * These are signals rather than plain fields because Angular 22 runs zoneless:
 * a routed page writing to a plain property would not schedule change
 * detection, so the header would never update. Signals do.
 */
@Injectable({ providedIn: 'root' })
export class CommonService {
  readonly isHomePage = signal(false);
  readonly imageTitle = signal('');

  /** Called by every page except home, with its own title image. */
  showTitle(imagePath: string): void {
    this.imageTitle.set(imagePath);
    this.isHomePage.set(false);
  }

  /** Home hides the header entirely. */
  showHome(): void {
    this.isHomePage.set(true);
  }
}
